// shows a sticky submit button when changes are made

const $ = require('jquery');

$(function () {
  const banner = $('#submit-panel');
  banner.hide();
  banner.removeClass('hidden');

  return $('#edit-asset-form').change(() => banner.slideDown());
});
